import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Paper,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Modal,
  IconButton,
  List,
  Badge,
} from "@material-ui/core";
import ShoppingCartIcon from "@mui/icons-material/AssignmentOutlined";
import { green } from "@mui/material/colors";
import LeftNav from "./LeftNav";
import "./SI180Dashboard.css";
import Pagination from "@material-ui/lab/Pagination";
import { fetchCategoryItems, fetchTableLocation } from "services/api/si180Api";
import Table from "@mui/material/Table";
import TableFooter from "@mui/material/TableFooter";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { groupByMenu } from "services/dataOperations";
import MenuItemsModifiers from "./MenuItemsModifiers";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    minWidth: 200,
    backgroundColor: theme.palette.grey[300], // Assuming you have greyColor defined in your theme
  },
  label: {
    fontSize: "1rem",
  },
  menuItem: {
    fontSize: "1rem",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto", // Adjust width based on the content or set max-width
  maxHeight: "100vh", // Maximum height to allow scrolling
  overflowY: "auto", // Enable vertical scrolling
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const primColor = process.env.REACT_APP_SI180_PRIMCOLOR;
const textColor = process.env.REACT_APP_TEXT_COLOR;
const btnColor = process.env.REACT_APP_SI180_BTNCOLOR;
const greyColor = process.env.REACT_APP_SI180_BGGREY;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const itemImgSrc = process.env.REACT_APP_IMAGE_SRC;
const secColor = process.env.REACT_APP_SI180_SECCOLOR;
const itemsPerPage = 8; // Number of items you want per page

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

function priceRow(qty, unit) {
  return qty * unit;
}

function createRow(desc, qty, unit) {
  const price = priceRow(qty, unit);
  return { desc, qty, unit, price };
}

const rows = [
  createRow("Apple Juice", 5, 3.0),
  createRow("Almond Salmon", 2, 15.0),
  createRow("Beef Goulash", 3, 7.49),
];

// Accessing the description of each item
const appleJuiceDesc = rows[0].desc; // "Apple Juice"
const almondSalmonDesc = rows[1].desc; // "Almond Salmon"
const beefGoulashDesc = rows[2].desc; // "Beef Goulash"

const invoiceSubtotal = rows.reduce((sum, row) => sum + row.price, 0);

const ResidentMenuItems = ({ onResidentLookup }) => {
  const [checkNumber] = useState("12345");
  const [currentUser] = useState({
    firstName: JSON.parse(sessionStorage.getItem("selectedCustomer")).FirstName,
    lastName: JSON.parse(sessionStorage.getItem("selectedCustomer")).LastName,
    roomNumber: JSON.parse(sessionStorage.getItem("selectedCustomer")).Address1,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [menuItems, setMenuItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(
    sessionStorage.getItem("selectedCategory")
  );

  const [openModal, setOpenModal] = useState(false);

  const [selectedItem, setSelectedItem] = useState();
  const [itemCount, setItemCount] = useState(1);

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const [orderOption, setOrderOption] = useState("orderToday");

  const [open, setOpen] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [quantity, setQuantity] = useState();
  const [tableLocation, setTableLocation] = useState();

  const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
  const groupCartItems = groupByMenu(cartItems);
  console.log("cartItems", cartItems);
  useEffect(async () => {
    try {
      const data = await fetchCategoryItems();
      setMenuItems(data);
      setPage(1); // Reset to page 1 when menuItems are fetched/updated
    } catch (error) {
      console.error("fetchCategoryItems failed:", error);
    }
  }, [selectedCategory]);

  useEffect(async () => {
    try {
      const data = await fetchTableLocation();

      setTableLocation(
        data.sort((a, b) => {
          return a.TableName.localeCompare(b.TableName, undefined, {
            numeric: true,
          });
        })
      );
    } catch (error) {
      console.error("fetchTableLocation failed:", error);
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedCategory(sessionStorage.getItem("selectedCategory"));
    };

    window.addEventListener("storageChange", handleStorageChange);

    return () => {
      window.removeEventListener("storageChange", handleStorageChange);
    };
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1); // Reset to first page on search
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleCheckout = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [tableNumber, setTableNumber] = useState(""); // State for storing selected table number
  const handleTableChange = (event) => {
    setTableNumber(event.target.value);
  };

  const filteredItems = menuItems.filter((item) =>
    item.ItemName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedItems = filteredItems.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handleOrderOptionChange = (event) => {
    setOrderOption(event.target.value);
  };

  const timer = React.useRef();

  const buttonSx = {
    ...(success
      ? {
          bgcolor: "#265E08",
          "&:hover": {
            bgcolor: green[700],
          },
        }
      : {
          backgroundColor: "#265E08",
        }),
    color: textColor,
  };

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleButtonClick = () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      timer.current = setTimeout(() => {
        setSuccess(true);
        setLoading(false);
      }, 2000);
    }
  };

  const handleOpenEdit = (item) => {
    const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
    const cartItem = cartItems.find((i) => i.ItemID === item.ItemID);
    setSelectedItem(cartItem);
    setItemCount(cartItem?.quantity);
    setOpenEdit(true);
  };
  const handleCloseEdit = () => setOpenEdit(false);
  const handleDeleteEdit = () => {
    // Handle delete logic
    console.log("Item deleted");
    handleCloseEdit();
  };
  const handleSaveEdit = () => {
    // Handle update logic
    console.log("Changes saved");
    handleCloseEdit();
  };

  const handleClickOpenSubmit = () => {
    setOpen(true);
  };

  const handleConfirm = () => {
    console.log("Order confirmed");
    // Process the order submission logic here
    setOpen(false);
  };

  const handleClickOpen = (item) => {
    setSelectedItem(item);
    setItemCount(1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddToCheck = () => {
    const cartItems = JSON.parse(sessionStorage.getItem("cartItems")) || [];
    // Find the item in the cart
    const existingItemIndex = cartItems.findIndex(
      (item) => item.ItemID === selectedItem.ItemID
    );

    // If the item is already in the cart, update its quantity
    if (existingItemIndex !== -1) {
      const updatedCartItems = cartItems.map((item, index) => {
        if (index === existingItemIndex) {
          return {
            ...item,
            quantity: openEdit ? itemCount : item.quantity + itemCount,
          };
        }
        return item;
      });

      // Update cart items in sessionStorage
      sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    } else {
      // If the item is not in the cart, add it
      const updatedCartItems = [
        ...cartItems,
        {
          ...selectedItem,
          quantity: itemCount,
          menu: sessionStorage.getItem("selectedMenu"),
        },
      ];

      // Update cart items in sessionStorage
      sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    }

    console.log("cartItems", cartItems);
    handleClose();
  };

  const getTotalPrice = () => {
    // Calculate total price by summing up the price * quantity for each item
    const totalPrice = cartItems.reduce((total, item) => {
      return total + item.DefaultPrice * item.quantity;
    }, 0); // Start the total at 0

    return totalPrice;
  };

  const deleteItemFromCart = () => {
    // Filter out the item with the specified ItemID
    const updatedCartItems = cartItems.filter(
      (item) => item.ItemID !== selectedItem.ItemID
    );

    // Update cart items in sessionStorage
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
  };

  const orderOptions = ["Now", "Today", "Tomorrow"];
  const selectedOrderIndex = parseInt(
    sessionStorage.getItem("selectedOrderOption"),
    10
  );
  console.log("selectedOrderIndex", selectedOrderIndex);
  const selectedOrderText = orderOptions[selectedOrderIndex] || "Tomorrow"; // Default to "Tomorrow" if index is out of bounds
  const classes = useStyles();

  return (
    <div className="dashboard">
      <LeftNav onResidentLookup={onResidentLookup} />
      <div className="right-pane" style={{ backgroundColor: "white" }}>
        <IconButton
          onClick={handleCheckout}
          style={{
            position: "absolute",
            right: 20,
            top: 20,
            backgroundColor: "#265E08",
            padding: "1.125rem",
            color: textColor,
          }}
        >
          <Badge badgeContent={cartItems.length} color="primary">
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
        {/* Edit Item Modal   */}
        <Dialog
          open={openEdit}
          onClose={handleCloseEdit}
          aria-labelledby="form-dialog-title"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DialogTitle
            id="form-dialog-title"
            style={{
              color: "primary",
              fontWeight: 550,
            }}
          >
            Edit Item
          </DialogTitle>
          <IconButton
            onClick={handleCloseEdit}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              backgroundColor: "#d33",
              borderRadius: "50%",
              padding: "12px",
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minWidth: "250px",
                  height: "100%",
                }}
              >
                <Typography
                  style={{
                    fontSize: "large",
                    textAlign: "left",
                    paddingRight: ".5rem",
                  }}
                >
                  {selectedItem?.ItemName}
                </Typography>
                <IconButton
                  style={{
                    color: textColor,
                    backgroundColor: btnColor,
                    padding: "1rem",
                  }}
                  onClick={() => {
                    deleteItemFromCart(selectedItem.ItemID);
                    handleCloseEdit();
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                minWidth: "250px",
                height: "100%",
              }}
            >
              <Typography
                style={{
                  fontSize: "large",
                  textAlign: "left",
                  paddingRight: ".5rem",
                }}
              >
                Quantity:
              </Typography>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                  marginTop: ".5rem",
                  height: "100%",
                }}
              >
                <IconButton
                  style={{
                    color: textColor,
                    backgroundColor: btnColor,
                    padding: "1rem",
                  }}
                  onClick={() =>
                    setItemCount((count) => Math.max(count - 1, 1))
                  }
                >
                  <RemoveIcon />
                </IconButton>
                <Box
                  style={{
                    padding: "0 .5rem",
                    fontSize: "large",
                    fontWeight: "550",
                  }}
                >
                  {itemCount}
                </Box>
                <IconButton
                  style={{
                    color: textColor,
                    backgroundColor: btnColor,
                    padding: "1rem",
                  }}
                  onClick={() => setItemCount((count) => count + 1)}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleAddToCheck();
                handleCloseEdit();
              }}
              className="si180btn"
              sx={buttonSx}
              style={{
                backgroundColor: "#265E08",
                color: textColor,
                minWidth: "150px",
                height: "72px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        {/* End of Edit Item Modal */}

        {/* Order Information Modal */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ minHeight: "100%", overflowY: "auto" }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={style}>
              <IconButton
                onClick={handleCloseModal}
                style={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                  backgroundColor: "#d33",
                  borderRadius: "50%",
                  padding: "12px",
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>

              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{
                  textAlign: "center",
                  fontWeight: 550,
                  marginBottom: "10px",
                }}
              >
                Order Information
              </Typography>
              <div style={{ textAlign: "left", color: primColor }}>
                <Typography
                  style={{
                    fontSize: "1rem",
                    lineHeight: "1.125",
                  }}
                >
                  {currentUser.firstName} {currentUser.lastName}
                </Typography>
                <Typography
                  style={{
                    fontSize: "1rem",
                    lineHeight: "1.125",
                  }}
                >
                  Room #: {currentUser.roomNumber}
                </Typography>
                <Typography
                  style={{
                    fontSize: "1rem",
                    lineHeight: "1.125",
                  }}
                >
                  Check #: {checkNumber}
                </Typography>
              </div>
              <Box style={{ textAlign: "center" }}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel
                    id="table-select-label"
                    className={classes.label}
                    style={{
                      fontSize: "large",
                      textAlign: "left",
                      marginTop: "4px",
                    }}
                  >
                    Select a Table
                  </InputLabel>
                  <Select
                    labelId="table-select-label"
                    id="table-select"
                    value={tableNumber}
                    onChange={handleTableChange}
                    label="Select a Table"
                    style={{
                      fontSize: "larger",
                      textAlign: "left",
                      marginTop: ".5rem",
                    }}
                  >
                    <MenuItem
                      value=""
                      className={classes.menuItem}
                      style={{
                        fontSize: "larger",
                        textAlign: "left",
                        marginTop: ".5rem",
                      }}
                    >
                      <em>None</em>
                    </MenuItem>
                    {tableLocation?.map((table) => (
                      <MenuItem
                        key={table.SIC_ID}
                        value={table.TableName}
                        className={classes.menuItem}
                        style={{
                          fontSize: "larger",
                          textAlign: "left",
                          marginTop: ".5rem",
                        }}
                      >
                        {table.TableName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <TableContainer className="SpanningTable" component={Paper}>
                <Table aria-label="spanning table">
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                    }}
                  >
                    <TableHead>
                      {/* <TableRow>
                    <TableCell
                      align="center"
                      colSpan={3}
                      style={{ fontSize: "medium", color: textColor }}
                    >
                      Lunch Menu
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ fontSize: "medium", color: textColor }}
                    >
                      Price
                    </TableCell>
                  </TableRow> */}
                      <TableRow>
                        <TableCell
                          align="left"
                          style={{
                            fontSize: "medium",
                            color: textColor,
                            padding: ".75rem",
                            lineHeight: 1.1,
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            fontSize: "medium",
                            color: textColor,
                            padding: ".75rem",
                            lineHeight: 1.1,
                          }}
                        >
                          Unit Price
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{
                            fontSize: "medium",
                            color: textColor,
                            padding: ".75rem",
                            lineHeight: 1.1,
                          }}
                        >
                          Quantity
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            fontSize: "medium",
                            color: textColor,
                            padding: ".75rem",
                            lineHeight: 1.1,
                          }}
                        >
                          Total Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ fontSize: "medium" }}>
                      {Object.entries(groupCartItems).map(([menu, items]) => (
                        <>
                          <TableRow key={menu}>
                            <TableCell
                              style={{
                                fontWeight: "bold",
                                fontSize: "medium",
                                backgroundColor: secColor,
                              }}
                              colSpan={4}
                            >
                              {menu}
                            </TableCell>
                          </TableRow>
                          {items.map((item) => (
                            <TableRow key={item.ItemID}>
                              <TableCell
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "left",
                                  fontSize: "medium",
                                  textAlign: "left",
                                  padding: ".5rem",
                                }}
                              >
                                <IconButton
                                  onClick={() => handleOpenEdit(item)}
                                  style={{
                                    paddingTop: "10px",
                                    zIndex: 1,
                                  }}
                                >
                                  <EditIcon />
                                </IconButton>
                                <span style={{ paddingLeft: "10px" }}>
                                  {item.ItemName}
                                </span>
                              </TableCell>
                              <TableCell
                                align="right"
                                style={{ fontSize: "medium", padding: ".5rem" }}
                              >
                                {parseFloat(
                                  item.DefaultPrice / 100
                                ).toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  minimumFractionDigits: 2,
                                })}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontSize: "medium", padding: ".5rem" }}
                              >
                                {item.quantity}
                              </TableCell>

                              <TableCell
                                align="right"
                                style={{ fontSize: "medium", padding: ".5rem" }}
                              >
                                {parseFloat(
                                  (item.DefaultPrice * item.quantity) / 100
                                ).toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  minimumFractionDigits: 2,
                                })}
                              </TableCell>
                            </TableRow>
                          ))}
                        </>
                      ))}
                      <TableRow
                        style={{
                          position: "sticky",
                          bottom: "-1px",
                          zIndex: 10,
                        }}
                      >
                        <TableCell
                          rowSpan={3}
                          style={{
                            fontSize: "large",
                            fontWeight: 550,
                            backgroundColor: greyColor,
                          }}
                        />
                        <TableCell
                          colSpan={2}
                          style={{
                            fontSize: "large",
                            fontWeight: 550,
                            backgroundColor: greyColor,
                          }}
                        >
                          Total
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            fontSize: "large",
                            fontWeight: 550,
                            backgroundColor: greyColor,
                          }}
                        >
                          {parseFloat(getTotalPrice() / 100).toLocaleString(
                            "en-US",
                            {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                            }
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </div>
                </Table>
              </TableContainer>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "1rem",
                }}
              >
                <Button
                  className="si180btn"
                  sx={buttonSx}
                  style={{
                    backgroundColor: secColor,
                    color: textColor,
                    maxWidth: "200px",
                    height: "72px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    sessionStorage.removeItem("cartItems");
                    handleCloseModal();
                  }}
                >
                  Clear Order
                </Button>
                <Button
                  className="si180btn"
                  sx={buttonSx}
                  style={{
                    backgroundColor: "#265E08",
                    color: textColor,
                    maxWidth: "200px",
                    height: "72px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Submit Order
                </Button>
              </div>
            </Box>
          </Grid>
        </Modal>
        {/* End of Order Information Modal */}
        <div style={{ textAlign: "center", color: primColor }}>
          <Typography style={{ fontSize: "1.125rem", lineHeight: "1.25" }}>
            Order {selectedOrderText} for
          </Typography>
          <Typography
            style={{
              fontSize: "1.25rem",
              lineHeight: "1.25",
              fontWeight: "500",
            }}
          >
            {currentUser.firstName} {currentUser.lastName}
          </Typography>
          <Typography
            style={{
              fontSize: "1.25rem",
              lineHeight: "1.25",
              fontWeight: "500",
            }}
          >
            Room #: {currentUser.roomNumber}
          </Typography>
        </div>
        <Paper
          style={{ padding: 10, backgroundColor: btnColor, marginTop: "1rem" }}
        >
          <Grid container className="resMenu" alignItems="center">
            <Grid item>
              <Typography variant="h5" style={{ color: textColor }}>
                {sessionStorage.getItem("selectedMenu")}
              </Typography>
              <Typography variant="subtitle1" style={{ color: textColor }}>
                Check Number: {checkNumber}
              </Typography>
            </Grid>
            <Grid item>
              <input
                className="si180btn"
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </Grid>
          </Grid>
        </Paper>
        <Grid container spacing={2} justify="left" style={{ marginTop: 10 }}>
          {paginatedItems.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
              <Card
                style={{
                  cursor: "pointer",
                  height: "230px",
                  backgroundColor: greyColor,
                }}
                onClick={() => handleClickOpen(item)}
              >
                <CardMedia
                  style={{ height: 90 }}
                  image={
                    item.FileName
                      ? `${itemImgSrc}${item.FileName}`
                      : `${siteMedSrc}empty-img.png`
                  }
                  title={item.ItemName}
                />
                <CardContent style={{ paddingBottom: ".5rem" }}>
                  <Typography
                    gutterBottom
                    variant="h6"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item.ItemName}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item.ItemDescription}
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                      color: "#E53935",
                      lineHeight: 2,
                    }}
                  >
                    {parseFloat(item.DefaultPrice / 100).toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                      }
                    )}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              backgroundColor: "#d33",
              borderRadius: "50%",
              padding: "12px",
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <CardContent>
            <Typography gutterBottom style={{ fontSize: "x-large" }}>
              {selectedItem?.ItemName}
            </Typography>

            <Grid
              container
              spacing={1}
              alignItems="flex-start"
              justifyContent="space-between"
            >
              <Grid item xs={12} sm={4} md={3} lg={3}>
                <CardMedia
                  style={{
                    width: "100%",
                    paddingTop: "100%", // Maintains a 1:1 aspect ratio
                    boxShadow: `inset #fff 0 0 0 2px, 
                                inset #fff 0 0 0 4px, 
                                inset #ccc 0 0 0 8px, 
                                inset #999 0 0 0 10px
                              `,
                    textShadow: "3px 3px 1px #999",
                  }}
                  image={
                    selectedItem?.FileName
                      ? `${itemImgSrc}${selectedItem?.FileName}`
                      : `${siteMedSrc}empty-img.png`
                  }
                  title={selectedItem?.ItemName}
                />
              </Grid>
              <Grid className="DialogDesc" item xs={12} sm={8} md={9} lg={9}>
                <Typography
                  style={{
                    textAlign: "start",
                    fontSize: "normal",
                    lineHeight: "1.25",
                  }}
                >
                  {selectedItem?.ItemDescription}
                </Typography>
              </Grid>
              <div>
                <Typography
                  style={{
                    color: "#E53935",
                    fontSize: "x-large",
                  }}
                >
                  {parseFloat(selectedItem?.DefaultPrice / 100).toLocaleString(
                    "en-US",
                    {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 2,
                    }
                  )}
                </Typography>
              </div>
            </Grid>
            <MenuItemsModifiers item={selectedItem} />
            <Grid
              container
              style={{
                display: "flex",
                justifyContent: "space-between",
                minWidth: "250px",
                height: "100%",
              }}
            >
              <Grid
                className="QtyAddCheck"
                item
                xs={12}
                sm={7}
                md={8}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontSize: "large",
                    textAlign: "left",
                    paddingRight: ".5rem",
                  }}
                >
                  Quantity:
                </Typography>
                <IconButton
                  style={{
                    color: textColor,
                    backgroundColor: btnColor,
                    padding: "1rem",
                  }}
                  onClick={() =>
                    setItemCount((count) => Math.max(count - 1, 1))
                  }
                >
                  <RemoveIcon />
                </IconButton>
                <Box
                  style={{
                    padding: "0 .5rem",
                    fontSize: "large",
                    fontWeight: "550",
                  }}
                >
                  {itemCount}
                </Box>
                <IconButton
                  style={{
                    color: textColor,
                    backgroundColor: btnColor,
                    padding: "1rem",
                  }}
                  onClick={() => setItemCount((count) => count + 1)}
                >
                  <AddIcon />
                </IconButton>
              </Grid>
              <Grid
                className="QtyAddCheck"
                item
                xs={12}
                sm={5}
                md={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  onClick={handleAddToCheck}
                  className="si180btn"
                  sx={buttonSx}
                  style={{
                    backgroundColor: "#265E08",
                    color: textColor,
                    maxWidth: "200px",
                    height: "60px",
                  }}
                >
                  Add to Check
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Dialog>

        {filteredItems.length > itemsPerPage && (
          <Pagination
            count={Math.ceil(filteredItems.length / itemsPerPage)}
            page={page}
            onChange={handlePageChange}
            color="primary"
            style={{
              marginTop: 20,
              justifyContent: "center",
              display: "flex",
              listStyleType: "none",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ResidentMenuItems;
